import Axios from 'axios'
import qs from 'qs'
import device from '@/utils/device';

const PRE_URL = process.env.VUE_APP_API // 请求前缀（从环境变量里取）

const languages = {
  'zh': 'zh_CN',
  'en': 'en_US',
  'ja': 'ja_JP',
  'ko': 'ko_KR'
}

Axios.interceptors.request.use(
  config => {
    config.headers['version'] = '1.0.0'
    config.headers['lang'] = languages[getLang()]
    config.headers['terminal'] = device.terminal
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

/*
* 获取语言
* */
const getLang = () => {
  if (window) {
    if (localStorage.getItem('locale')) {
      return localStorage.getItem('locale')
    }
    localStorage.setItem('locale', 'zh')
    return 'zh'
  }
  return 'zh'
}

/*
* 获取通用请求参数
* */
const getCommonsPrms = () => {
  return {
    language: languages[getLang()],
    app_key: 'eishohh5Joope2ohc6ac',
    terminal_type: 2
  }
}

/*
* get请求
* */
const axGet = (apiPath, params) => {
  params = params ? { ...getCommonsPrms(), ...params } : getCommonsPrms()
  return Axios.get(PRE_URL + apiPath, { params })
}

/*
* post请求
* */
const axPost = (apiPath, params) => {
  params = params ? { ...getCommonsPrms(), ...params } : getCommonsPrms()
  Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  params = qs.stringify(params)
  return Axios.post(PRE_URL + apiPath, params)
}

/**
 * 验证手机号
 * @param phone
 * @returns {boolean}
 */
export function verifyPhone (phone) {
  if (!phone || phone === '') {
    return false
  }
  let regExp = /^[1]([3-9])[0-9]{9}$/
  return regExp.test(phone)
}

export { axGet, axPost, getLang }
